import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { ContrastSection } from '../components/ContrastSection';
import { StickyCTA } from '../components/StickyCTA';
/* Lazy-load only truly below-fold sections to reduce network waterfall.
   Grouped into two Suspense boundaries to minimize chunk requests. */
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const KitTacticoSection = lazy(() => import('../components/KitTacticoSection').then(m => ({
  default: m.KitTacticoSection
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-250">
      {/* Above-fold: eagerly loaded for fastest FCP/LCP */}
      <HeroSection data-id="element-251" />
      <TrustBar data-id="element-252" />
      <ContrastSection data-id="element-253" />

      {/* Near-fold: lazy but grouped */}
      <Suspense fallback={null} data-id="element-254">
        <ForWhomSection data-id="element-255" />
        <BenefitsSection data-id="element-256" />
        <ContentPreview data-id="element-257" />
        <KitTacticoSection data-id="element-258" />
        <BonusSection data-id="element-259" />
        <PricingSection data-id="element-260" />
      </Suspense>

      {/* Far below fold */}
      <Suspense fallback={null} data-id="element-261">
        <GuaranteeSection data-id="element-262" />
        <ExpertSection data-id="element-263" />
        <FAQSection data-id="element-264" />
        <Footer data-id="element-265" />
        <SocialProofPopup data-id="element-266" />
      </Suspense>

      <StickyCTA data-id="element-267" />
    </main>;
}